import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

function Header() {
    const navigate = useNavigate();

    // Check if a user is logged in
    const username = localStorage.getItem('username');
    const organizationName = localStorage.getItem('organizationName'); 

    const handleLogout = () => {
        // Clear localStorage on logout
        localStorage.clear();
        navigate('/'); // Redirect to homepage after logout
    };

    return (
        <AppBar position="static" sx={{ backgroundColor: '#333' }}>
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                {/* Logo */}
                <Typography
                    variant="h6"
                    component={Link}
                    to="/"
                    sx={{
                        textDecoration: 'none',
                        color: 'white',
                        fontWeight: 'bold',
                    }}
                >
                    SciCruit
                </Typography>

                {/* Navigation Links */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Button
                        component={Link}
                        to="/"
                        sx={{ color: 'white', textTransform: 'none' }}
                    >
                        Home
                    </Button>
                    <Button
                        component={Link}
                        to="/about"
                        sx={{ color: 'white', textTransform: 'none' }}
                    >
                        About
                    </Button>
                    
                    {/* Show Dashboard & Logout if Logged In */}
                    {username ? (
                        <>
                            <Typography
                                variant="subtitle1"
                                sx={{ color: 'white', marginRight: 2 }}
                            >
                                {organizationName ? `${organizationName}'s Dashboard` : "Dashboard"}
                            </Typography>
                            <Button
                                onClick={handleLogout}
                                sx={{
                                    color: 'white',
                                    textTransform: 'none',
                                    backgroundColor: '#dc3545',
                                    marginLeft: 2,
                                    padding: '5px 15px',
                                    borderRadius: '5px',
                                    '&:hover': { backgroundColor: '#c82333' },
                                }}
                            >
                                Logout
                            </Button>
                        </>
                    ) : (
                        <>
                            {/* Show Login & Signup if NOT logged in */}
                            <Button
                                component={Link}
                                to="/login"
                                sx={{ color: 'white', textTransform: 'none' }}
                            >
                                Login
                            </Button>
                            <Button
                                component={Link}
                                to="/signup"
                                variant="outlined"
                                sx={{
                                    color: 'white',
                                    borderColor: 'white',
                                    textTransform: 'none',
                                    marginLeft: 1,
                                }}
                            >
                                Signup
                            </Button>
                        </>
                    )}
                </Box>
            </Toolbar>
        </AppBar>
    );
}

export default Header;

